<template>
  <section>
    <b-row>
      <b-col>
        <template
          v-if="
            userData.semesters &&
            userData.semesters.semesters &&
            userData.semesters.semesters.length
          "
        >
          <div
            v-for="(semester, semesterIndex) in userData.semesters.semesters"
            :key="semesterIndex"
          >
            <b-col md="3" cols="12" class="mx-auto relative my-3">
              <div>
                <div>
                  <div
                    class="d-flex flex-wrap justify-content-center align-items-center mb-1"
                  >
                    <b-link
                      class="d-flex justify-content-center"
                      :to="{
                        name: 'show-semester',
                        params: { id: semester.id },
                      }"
                    >
                      <h4>{{ semester.name }}</h4>
                    </b-link>
                  </div>

                  <div
                    class="d-flex justify-content-between align-items-center flex-wrap mb-2"
                    v-if="!semester.bought && semester.can_buy"
                  >
                    <div
                      class="d-flex w-100 align-items-center justify-content-between"
                    >
                      <div class="d-flex">
                        <h6 class="mr-1">شهریه‌ :</h6>
                        <h6 class="d-flex justify-content-center">
                          <span
                            class="text-danger"
                            v-if="
                              finalAmount(semester) != 0 &&
                              finalAmount(semester) != semester.amount
                            "
                            style="text-decoration: line-through"
                          >
                            {{ numberWithCommas(semester.amount) }}
                          </span>
                          <span class="text-success"
                            >{{
                              finalAmount != 0
                                ? numberWithCommas(finalAmount(semester)) +
                                  " تومان "
                                : "رایگان"
                            }}
                          </span>
                        </h6>
                      </div>
                      <div class="d-flex ml-auto">
                        <b-button
                          variant="gradient-success"
                          @click="checkoutSemester(semester)"
                        >
                          خرید ترم
                        </b-button>
                      </div>
                    </div>
                    <div class="my-md-0 my-2 px-0">
                      <div
                        class="justify-content-center flex-wrap text-info font-weight-bold font-weight-bold w-100"
                        v-show="
                          !semester.bought && availableAtTimer[semesterIndex]
                        "
                      >
                        <div class="align-center mb-50">
                          زمان باقی مانده تا شروع ثبت نام :
                        </div>

                        <timer
                          class="flex-row w-100"
                          color="info"
                          :time="semester.available_at"
                          v-model="availableAtTimer[semesterIndex]"
                        />
                      </div>
                      <div
                        class="justify-content-center flex-wrap text-info font-weight-bold text-danger"
                        v-show="
                          !semester.bought &&
                          !availableAtTimer[semesterIndex] &&
                          unavailableAtTimer[semesterIndex]
                        "
                      >
                        <div class="align-center mb-50">
                          زمان باقی مانده تا پایان مهلت ثبت نام :
                        </div>
                        <timer
                          class="flex-row"
                          color="danger"
                          :time="semester.unavailable_at"
                          v-model="unavailableAtTimer[semesterIndex]"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="w-100" v-if="semester.bought">
                    <b-badge
                      variant="light-success"
                      class="mb-75 w-100 font-weight-bolder p-75"
                    >
                      <h6 class="text-success mb-0">
                        شما دانشجوی این ترم هستید
                      </h6>
                    </b-badge>
                  </div>
                  <div
                    class="w-100"
                    v-if="!semester.bought && !semester.can_buy"
                  >
                    <b-badge
                      variant="light-warning"
                      class="mb-75 w-100 font-weight-bolder p-75"
                    >
                      <h6 class="text-warning mb-0">
                        مهلت ثبت نام به پایان رسیده است
                      </h6>
                    </b-badge>
                  </div>
                </div>
              </div>
            </b-col>
            <div
              :class="[
                'd-flex',
                index == 0
                  ? 'flex-md-row flex-column'
                  : index % 2 == 0
                  ? 'flex-md-row flex-column'
                  : 'flex-md-row-reverse flex-column',
              ]"
              v-for="(roadmap, index) in semester.roadmaps.roadmaps"
              :key="index"
            >
              <b-col
                md="2"
                cols="12"
                class="d-flex justify-content-center align-items-center px-0 mb-md-0 mb-2"
              >
                <div
                  class="justify-content-center align-items-center rounded-circle h2 mb-0 text-white d-md-none d-flex"
                  style="width: 80px; height: 80px"
                  :style="[{ backgroundColor: randomColor[index] }]"
                >
                  {{ index + 1 }}
                
                   <div
                    v-if="index !== 0"
                    class="position-absolute position-bottom-100 h-50 zindex-minus-1"
                    :style="[
                      { width: '4px', backgroundColor: randomColor[index] },
                    ]"
                  ></div>
                  <div
                    class="position-absolute position-top-100 h-50 zindex-minus-1"
                    :style="[
                      { width: '4px', backgroundColor: randomColor[index] },
                    ]"
                  ></div>
                </div>
                <div
                  class="justify-content-center align-items-center rounded-circle display-4 text-white d-md-flex d-none"
                  style="width: 110px; height: 110px"
                  :style="[{ backgroundColor: randomColor[index] }]"
                >
                  {{ index + 1 }}
                  <div
                    :class="[
                      'position-absolute  w-50 zindex-minus-1 ',
                      index == 0
                        ? 'position-right-0'
                        : index % 2 == 0
                        ? 'position-right-0'
                        : 'position-left-0',
                    ]"
                    :style="[
                      { height: '4px', backgroundColor: randomColor[index] },
                    ]"
                  ></div>
                  <div
                    v-if="index !== semester.roadmaps.roadmaps.length - 1"
                    class="position-absolute position-bottom-0 h-50 zindex-minus-1"
                    :style="[
                      { width: '4px', backgroundColor: randomColor[index] },
                    ]"
                  ></div>
                </div>
              </b-col>
              <b-col md="10" cols="12" class="px-0">
                <b-card body-class="p-md-0 " class="overflow-hidden">
                  <b-row
                    :class="[
                      'flex-column-reverse ',
                      index == 0
                        ? 'flex-md-row-reverse'
                        : index % 2 == 0
                        ? 'flex-md-row-reverse'
                        : 'flex-md-row',
                    ]"
                  >
                    <b-col
                      cols="12"
                      md="9"
                      :class="[
                        'd-flex flex-column py-2 ',
                        index == 0
                          ? 'pl-md-0 pr-md-3'
                          : index % 2 == 0
                          ? 'pl-md-0 pr-md-3'
                          : 'pr-md-0 pl-md-3',
                      ]"
                    >
                      <div
                        class="d-flex flex-wrap justify-content-between border-bottom pb-1 my-50"
                      >
                        <b-link
                          :to="{
                            name: 'show-course',
                            params: { id: roadmap.item.id },
                          }"
                        >
                          <h5>
                            {{ roadmap.item.name || roadmap.item.title }}
                          </h5>
                        </b-link>
                        <div class="d-flex align-items-center">
                          <b-badge
                            v-if="roadmap.vip"
                            class="d-flex align-items-center mr-1"
                            variant="danger"
                          >
                            VIP
                          </b-badge>
                          <b-badge
                            class="d-flex align-items-center"
                            :variant="
                              roadmap.item.active ? 'success' : 'secondary'
                            "
                          >
                            {{ roadmap.item.active ? "فعال" : "غیر فعال" }}
                          </b-badge>
                        </div>
                      </div>

                      <div
                        class="d-flex align-items-center w-100 justify-content-between flex-wrap"
                      >
                        <div class="mr-2" v-if="roadmap.item.started_at">
                          <span> تاریخ شروع :</span>
                          <span>
                            {{ calcDate(roadmap.item.started_at) }}
                          </span>
                        </div>
                        <div class="mr-2" v-if="roadmap.item.ended_at">
                          <span> تاریخ پایان :</span>
                          <span>
                            {{ calcDate(roadmap.item.ended_at) }}
                          </span>
                        </div>
                      </div>
                      <div>
                        <p
                          class="text-justify mb-0 mt-2"
                          v-html="roadmap.item.brief_description"
                        ></p>
                      </div>
                      <div
                        class="d-flex align-items-center w-100 justify-content-between"
                        v-if="!roadmap.item.bought && roadmap.item.can_buy"
                      >
                        <div>
                          <h6 class="d-flex justify-content-center my-1">
                            <span
                              class="text-danger"
                              v-if="
                                finalAmount(roadmap.item) != 0 &&
                                finalAmount(roadmap.item) != roadmap.amount
                              "
                              style="text-decoration: line-through"
                            >
                              {{ numberWithCommas(roadmap.item.amount) }}
                            </span>
                            <span class="text-success"
                              >{{
                                finalAmount != 0
                                  ? numberWithCommas(
                                      finalAmount(roadmap.item)
                                    ) + " تومان "
                                  : "رایگان"
                              }}
                            </span>
                          </h6>
                        </div>
                        <b-button
                          variant="gradient-success"
                          @click="checkoutCourse(roadmap.item)"
                        >
                          خرید دوره
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      md="3"
                      class="d-flex align-items-center position-relative"
                    >
                      <div
                        style="max-height: 100%"
                        class="d-flex justify-content-center align-items-center w-100 h-100"
                      >
                        <b-link
                          :to="{
                            name: 'show-course',
                            params: { id: roadmap.item.id },
                          }"
                          class="h-100"
                        >
                          <b-img
                            class="h-100"
                            @error="setAltImg"
                            :src="roadmap.item.banner || errorImage"
                            fluid
                          />
                        </b-link>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </div>
            <div
              class="my-4"
              v-if="semesterIndex != userData.semesters.semesters.length - 1"
            >
              <hr />
            </div>
          </div>
        </template>
      </b-col>
      <!-- <b-col
        cols="12"
        lg="4"
        v-if="
          Object.keys(chartjsDataSemester).length ||
          Object.keys(chartjsDataCourse).length
        "
      >
        <div class="sticky-sidebar">
          <hor
            :chartjsData="chartjsDataSemester"
            v-if="Object.keys(chartjsDataSemester).length"
            title="درصد پیشرفت ترم ها "
          />
          <hor
            :chartjsData="chartjsDataCourse"
            v-if="Object.keys(chartjsDataCourse).length"
            title="درصد پیشرفت دوره ها "
          />

           <progress-chart :radialBarChart="radialBarChartCourses" /> -->
      <!-- <progress-chart :radialBarChart="radialBarChartTerms" /> -->
      <!-- <comments /> -->
      <!-- <balance/> -->
      <!-- </div>
      </b-col>  -->
      <div class="px-2 w-100">
        <h5>
          <b-badge
            v-if="
              userData.semesters &&
              userData.semesters.semesters &&
              !userData.semesters.semesters.length &&
              !Object.keys(chartjsDataSemester).length &&
              !Object.keys(chartjsDataCourse).length
            "
            variant="light-secondary"
            class="w-100 p-2"
          >
            هیچ اطلاعاتی برای نمایش وجود ندارد
          </b-badge>
        </h5>
      </div>
    </b-row>
    <loader :loading="loader" />
  </section>
</template>

<script>
import {
  BAvatar,
  BAvatarGroup,
  BBadge,
  BButton,
  BCard,
  BCol,
  BCollapse,
  BImg,
  BLink,
  BListGroup,
  BListGroupItem,
  BMedia,
  BRow,
  VBToggle,
  VBTooltip,
  BAlert,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import Ripple from "vue-ripple-directive";
import ProgressChart from "./ProgressChart.vue";
// import Comments from "./Comments.vue";
// import Balance from "./Balance.vue";
import Hor from "./ChartjsHorizontalBarChart.vue";
import Loader from "@core/components/loader/Loader.vue";
import Timer from "@core/components/timer/Timer.vue";
import { $themeColors } from "@themeConfig";
import { created } from "vue-echarts";
const chartColors = {
  primaryColorShade: "#836AF9",
  yellowColor: "#ffe800",
  successColorShade: "#28dac6",
  warningColorShade: "#ffe802",
  warningLightColor: "#FDAC34",
  infoColorShade: "#299AFF",
  greyColor: "#4F5D70",
  blueColor: "#2c9aff",
  blueLightColor: "#84D0FF",
  greyLightColor: "#EDF1F4",
  tooltipShadow: "rgba(0, 0, 0, 0.25)",
  lineChartPrimary: "#666ee8",
  lineChartDanger: "#ff4961",
  labelColor: "#6e6b7b",
  grid_line_color: "rgba(200, 200, 200, 0.2)",
};

export default {
  components: {
    BRow,
    BCol,
    BCard,
    AppTimeline,
    AppTimelineItem,
    BImg,
    BMedia,
    BAvatar,
    BButton,
    BCollapse,
    BListGroup,
    BListGroupItem,
    BAvatarGroup,
    BBadge,
    ProgressChart,
    Loader,
    // Comments,
    // Balance,
    Hor,
    BLink,
    Timer,
    BAlert,
  },
  directives: { "b-toggle": VBToggle, "b-tooltip": VBTooltip, Ripple },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      randomColor: [
        "#fc5c65",
        "#fd9644",
        "#f7b731",
        "#20bf6b",
        "#0fb9b1",
        "#45aaf2",
        "#4b7bec",
        "#a55eea",
        "#d1d8e0",
        "#778ca3",
        "#4b6584",
        "#3867d6",
      ],
      courses: [],
      loader: false,
      loading: false,
      radialBarChartCourses: {},
      radialBarChartTerms: {},
      chartjsDataSemester: {},
      chartjsDataCourse: {},
      availableAtTimer: [],
      unavailableAtTimer: [],
    };
  },
  async created() {
    if (this.userData.semesters && this.userData.semesters.semesters) {
      this.userData.semesters.semesters.forEach((semester, index) => {
        this.availableAtTimer[index] = true;
        this.unavailableAtTimer[index] = true;
      });
    }
  },
  // async mounted() {
  //   this.loading = true;

  //   // await this.getCourses();
  //   await this.getDashboard();

  //   this.loading = false;
  // },

  methods: {
    finalAmount(item) {
      let finalAmount = 0;
      if (item.percentage) {
        finalAmount =
          Number(item.amount) -
          (Number(item.amount) * Number(item.rebate)) / 100;
      } else {
        finalAmount = Number(item.amount) - Number(item.rebate);
      }
      return finalAmount > 0 ? String(parseInt(finalAmount)) : "0";
    },
    async checkoutCourse(item) {
      this.loader = true;
      try {
        const { data } = await this.$http.post("/panel/invoices", {
          items: [
            {
              model: {
                id: item.id,
                type: "course",
              },
            },
          ],
        });
        this.loader = false;

        this.$router.push({
          name: "checkout",
          query: {
            invoice_id: data.data.id,
          },
        });
      } catch (err) {
        this.loader = false;
      }
    },
    async checkoutSemester(item) {
      this.loader = true;
      try {
        const { data } = await this.$http.post("/panel/invoices", {
          items: [
            {
              model: {
                id: item.id,
                type: "semester",
              },
            },
          ],
        });
        this.loader = false;

        this.$router.push({
          name: "checkout",
          query: {
            invoice_id: data.data.id,
          },
        });
      } catch (err) {
        this.loader = false;
      }
    },
    // async getDashboard() {
    //   try {
    //     const { data } = await this.$http.get("/panel/dashboard");

    //     if (
    //       data.data.progresses.semester &&
    //       Object.keys(data.data.progresses.semester).length
    //     ) {
    //       this.chartjsDataSemester = {
    //         horizontalBarChart: {
    //           options: {
    //             elements: {
    //               rectangle: {
    //                 borderWidth: 2,
    //                 borderSkipped: "top",
    //               },
    //             },
    //             tooltips: {
    //               // Updated default tooltip UI
    //               shadowOffsetX: 1,
    //               shadowOffsetY: 1,
    //               shadowBlur: 8,
    //               shadowColor: chartColors.tooltipShadow,
    //               backgroundColor: $themeColors.light,
    //               titleFontColor: $themeColors.dark,
    //               bodyFontColor: $themeColors.dark,
    //             },
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             responsiveAnimationDuration: 500,
    //             legend: {
    //               display: false,
    //             },
    //             scales: {
    //               xAxes: [
    //                 {
    //                   display: true,
    //                   gridLines: {
    //                     zeroLineColor: chartColors.grid_line_color,
    //                     borderColor: "transparent",
    //                     color: chartColors.grid_line_color,

    //                     drawTicks: false,
    //                   },
    //                   scaleLabel: {
    //                     display: true,
    //                   },
    //                   ticks: {
    //                     min: 0,
    //                     max: 100,
    //                     fontColor: chartColors.labelColor,
    //                   },
    //                 },
    //               ],
    //               yAxes: [
    //                 {
    //                   display: true,
    //                   gridLines: {
    //                     display: false,
    //                   },
    //                   scaleLabel: {
    //                     display: true,
    //                   },
    //                   ticks: {
    //                     fontColor: chartColors.labelColor,
    //                   },
    //                 },
    //               ],
    //             },
    //           },
    //           data: {
    //             labels: [
    //               ...data.data.progresses.semester.map((item) => item.label),
    //             ],
    //             datasets: [
    //               {
    //                 data: [
    //                   ...data.data.progresses.semester.map(
    //                     (item) => item.progress
    //                   ),
    //                 ],
    //                 backgroundColor: $themeColors.info,
    //                 borderColor: "transparent",
    //                 barThickness: 15,
    //               },
    //             ],
    //           },
    //         },
    //       };
    //     }

    //     if (
    //       data.data.progresses.course &&
    //       Object.keys(data.data.progresses.course).length
    //     ) {
    //       this.chartjsDataCourse = {
    //         horizontalBarChart: {
    //           options: {
    //             elements: {
    //               rectangle: {
    //                 borderWidth: 2,
    //                 borderSkipped: "top",
    //               },
    //             },
    //             tooltips: {
    //               // Updated default tooltip UI
    //               shadowOffsetX: 1,
    //               shadowOffsetY: 1,
    //               shadowBlur: 8,
    //               shadowColor: chartColors.tooltipShadow,
    //               backgroundColor: $themeColors.light,
    //               titleFontColor: $themeColors.dark,
    //               bodyFontColor: $themeColors.dark,
    //             },
    //             responsive: true,
    //             maintainAspectRatio: false,
    //             responsiveAnimationDuration: 500,
    //             legend: {
    //               display: false,
    //             },
    //             scales: {
    //               xAxes: [
    //                 {
    //                   display: true,
    //                   gridLines: {
    //                     zeroLineColor: chartColors.grid_line_color,
    //                     borderColor: "transparent",
    //                     color: chartColors.grid_line_color,

    //                     drawTicks: false,
    //                   },
    //                   scaleLabel: {
    //                     display: true,
    //                   },
    //                   ticks: {
    //                     min: 0,
    //                     max: 100,
    //                     fontColor: chartColors.labelColor,
    //                   },
    //                 },
    //               ],
    //               yAxes: [
    //                 {
    //                   display: true,
    //                   gridLines: {
    //                     display: false,
    //                   },
    //                   scaleLabel: {
    //                     display: true,
    //                   },
    //                   ticks: {
    //                     fontColor: chartColors.labelColor,
    //                   },
    //                 },
    //               ],
    //             },
    //           },
    //           data: {
    //             labels: [
    //               ...data.data.progresses.course.map((item) => item.label),
    //             ],
    //             datasets: [
    //               {
    //                 data: [
    //                   ...data.data.progresses.course.map(
    //                     (item) => item.progress
    //                   ),
    //                 ],
    //                 backgroundColor: $themeColors.info,
    //                 borderColor: "transparent",
    //                 barThickness: 15,
    //               },
    //             ],
    //           },
    //         },
    //       };
    //     }
    //     if (data.data.charts && data.data.charts.individual_growth) {
    //     }
    //   } catch (err) {}
    // },
    // async getCourses() {
    //   this.radialBarChartCourses = {
    //     title: "درصد پیشرفت دوره ها",
    //     series: [80, 50, 35, 35, 35, 35],
    //     chartOptions: {
    //       plotOptions: {
    //         radialBar: {
    //           size: 185,
    //           hollow: {
    //             size: "10%",
    //           },
    //           track: {
    //             margin: 15,
    //           },
    //           dataLabels: {},
    //         },
    //       },
    //       legend: {
    //         show: true,
    //         position: "bottom",
    //         horizontalAlign: "center",
    //       },
    //       stroke: {
    //         lineCap: "round",
    //       },
    //       labels: [
    //         " دوره ۱ ",
    //         " دوره ۲ ",
    //         " دوره ۳ ",
    //         " دوره ۱ ",
    //         " دوره ۲ ",
    //         " دوره ۳ ",
    //       ],
    //     },
    //   };
    //   this.radialBarChartTerms = {
    //     title: "درصد پیشرفت ترم ها",
    //     series: [80, 50, 35],
    //     chartOptions: {
    //       plotOptions: {
    //         radialBar: {
    //           size: 185,
    //           hollow: {
    //             size: "10%",
    //           },
    //           track: {
    //             margin: 15,
    //           },
    //           dataLabels: {},
    //         },
    //       },
    //       legend: {
    //         show: true,
    //         position: "bottom",
    //         horizontalAlign: "center",
    //       },
    //       stroke: {
    //         lineCap: "round",
    //       },
    //       labels: [" ترم ۱ ", " ترم ۲ ", " ترم ۳ "],
    //     },
    //   };
    //   // try {
    //   //   const { data } = await this.$http.get("/courses");
    //   //   this.courses = data.courses;
    //   // } catch (err) {
    //   // }
    // },
  },
};
</script>
<style></style>
